module.exports = __webpack_public_path__ + "img/68d7fb52e6f47e742c9cee49b19f03a9.png";